<template>
    <div>
        <el-row ref="back" class="main-back-moblie">
            <div @click="backHome">
                <li><img :src="images.backImg" /></li>
                <li><span>返回首页</span></li>
            </div>
        </el-row>
        <el-row ref="body" class="main-body-moblie" :style="{ height: mianHeight + 'px' }">
            <el-row class="body-img" :style="{ height: mianHeight - 100 + 'px' }">
                <img :src="currentRow.imgUrl" :style="{ width: this.bodyImg.width + 'px' }" />
            </el-row>

            <el-row class="body-text">
                <vue-seamless-scroll :data="wordList" :class-option="optionLeft" class="seamless-warp2"
                    :style="`width: ${divWidth * 0.6}px;height:50px;margin-top:${textMarginTop}px`">
                    <ul class="item" :style="`width: ${divWidth}px;height:50px;`">
                        <li v-for="(item, index) in wordList" :key="index">
                            <span>{{ item.key }}</span>
                            <span style="padding-bottom: 5px;">{{ item.words }}</span>
                            <span>{{ item.cnWords }}</span>
                        </li>
                    </ul>
                </vue-seamless-scroll>
            </el-row>
        </el-row>
        <el-row ref="setting" class="mian-setting-moblie">
            <el-col :span="12" style="text-align: left;">
                <a href="#" rel="sidebar" @click="addFavorite"><img :src="images.unfavariteImg" /></a>
            </el-col>
            <el-col :span="12" style="text-align: right;">
                <img :src="images.unclockImg" @click="showDrawerClockSetting">
                <el-drawer :visible.sync="drawerClockSetting" direction="btt" size="30">
                    <div :class="[clockSetting === 0 ? 'clock-check' : '', 'setting-clock']"
                        @click="clockHandlle($event, 0)">
                        不启用定时<i class="el-icon-check" v-if="clockSetting === 0"></i></div>
                    <div :class="[clockSetting === 10 ? 'clock-check' : '', 'setting-clock']"
                        @click="clockHandlle($event, 10)">
                        10分钟<i class="el-icon-check" v-if="clockSetting === 10"></i></div>
                    <div :class="[clockSetting === 20 ? 'clock-check' : '', 'setting-clock']"
                        @click="clockHandlle($event, 20)">
                        20分钟<i class="el-icon-check" v-if="clockSetting === 20"></i></div>
                    <div :class="[clockSetting === 30 ? 'clock-check' : '', 'setting-clock']"
                        @click="clockHandlle($event, 30)">
                        30分钟<i class="el-icon-check" v-if="clockSetting === 30"></i></div>
                </el-drawer>
            </el-col>
        </el-row>
        <el-row ref="progress" class="main-progress-moblie">
            <div style="padding: 0 20px; margin: 0 auto;">
                <el-slider v-model="percentage" :min="0" :max="100" :marks="marks" :show-tooltip="false"
                    @change="sliderChange"></el-slider>
            </div>
        </el-row>
        <el-row ref="tools" class="main-tools-moblie">
            <el-col :span="4">
                <img :src="images.uncircleImg" @click="loop" />
            </el-col>
            <el-col :span="4">
                <img :src="images.lastImg" @click="playLast" />
            </el-col>
            <el-col :span="8">
                <img v-if="audioPlaying" :src="images.playImg" @click="play" style="height: 55px;width: 55px;" />
                <img v-if="!audioPlaying" :src="images.unplayImg" @click="stop" style="height: 55px;width: 55px;" />
            </el-col>
            <el-col :span="4">
                <img :src="images.nextImg" @click="playNext" />
            </el-col>
            <el-col :span="4">
                <img :src="images.menuListImg" @click="showDrawerMenuList" />
                <el-drawer :visible.sync="drawerMenuList" direction="btt" size="40">
                    <div style="height:300px;overflow-y: auto;">
                        <el-table ref="tableMenu" :data="menuList" style="width: 100%;margin-bottom: 20px;"
                            row-key="key" :current-row-key="currentCode" @current-change="currentChange"
                            :expand-row-keys="expandrowkeys" :show-header="false" :highlight-current-row="true"
                            :tree-props="{ children: 'children' }">
                            <el-table-column prop="key" label="序号">
                                <template slot-scope="scope">
                                    <span>{{ scope.row.key }}</span>
                                    <span style="padding-left: 10px;" v-html="scope.row.text"></span>
                                    <span style="display: none;">{{ scope.row.code }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="words" label="单词">
                                <template slot-scope="scope">
                                    <span>{{ scope.row.words }}</span>
                                    <i class="el-icon-headset"
                                        style="display:inline-block;float: right; padding-right: 10px;"></i>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </el-drawer>
            </el-col>
        </el-row>
        <el-row style="display: none;">
            <audio ref="myaudio" :loop="audioSetting.isLoop" src="/" crossorigin="anonymous"></audio>
        </el-row>
    </div>
</template>
<script>
import api from '@/utils/api'
import vueSeamlessScroll from 'vue-seamless-scroll/src'
import favarite from '@/assets/images/listening-favarite.png'
import unfavarite from '@/assets/images/listening-unfavarite.png'
import clock from '@/assets/images/listening-clock.png'
import unclock from '@/assets/images/listening-unclock.png'
import back from '@/assets/images/listening-back.png'
import play from '@/assets/images/listening-play.png'
import pause from '@/assets/images/listening-pause.png'
import last from '@/assets/images/listening-last.png'
import next from '@/assets/images/listening-next.png'
import circle from '@/assets/images/listening-circle.png'
import uncircle from '@/assets/images/listening-uncircle.png'
import menuList from '@/assets/images/listening-menulist.png'
export default {
    name: 'QrStudy',
    components: { vueSeamlessScroll },
    data () {
        return {
            wordList: [{ title: '' }, { title: '' }],
            drawerClockSetting: false,
            drawerMenuList: false,
            myAudio: '',
            audioPlaying: false,
            audioSetting: {
                isLoop: false
            },
            bodyImg: {
                width: 0,
                height: 0
            },
            clockSetting: 0,
            marks: {
                0: '0.0',
                100: '0.0'
            },
            images: {
                favariteImg: favarite,
                unfavariteImg: unfavarite,
                clockImg: clock,
                unclockImg: unclock,
                backImg: back,
                playImg: play,
                unplayImg: pause,
                lastImg: last,
                nextImg: next,
                circleImg: circle,
                uncircleImg: uncircle,
                menuListImg: menuList
            },
            mianHeight: 0,
            percentage: 0,
            menuList: [],
            expandrowkeys: [],
            totalCount: 0,
            currentCode: '',
            currentLevel: 1,
            currentRow: '',
            divWidth: 0,
            textMarginTop: 0,
            timer: null
        }
    },
    created () {
        this.currentCode = this.$route.query.code
        this.initData()
    },
    mounted () {
        var _this = this
        window.onresize = () => {
            return (() => {
                _this.resizeWindow()
            })()
        }
        _this.resizeWindow()

        _this.myAudio = this.$refs.myaudio
        // _this.myAudio.addEventListener('timeupdate', _this.timeupdate)
        _this.myAudio.addEventListener('ended', _this.ended)
    },
    computed: {
        optionLeft () {
            return {
                direction: 2,
                limitMoveNum: this.wordList.length
            }
        }
    },
    methods: {
        resizeWindow: function () {
            this.divWidth = window.innerWidth

            this.mianHeight = window.innerHeight -
                this.$refs.back.$el.clientHeight -
                this.$refs.setting.$el.clientHeight -
                this.$refs.progress.$el.clientHeight -
                this.$refs.tools.$el.clientHeight - 5

            // 计算图片大小
            if (this.divWidth <= this.mianHeight - 100) {
                this.bodyImg.width = this.divWidth
            } else {
                this.bodyImg.width = this.mianHeight - 100
                this.textMarginTop = 10
            }
        },
        initData: function () {
            var code = this.currentCode
            this.$axios.get(api.getQrStudy(code))
                .then(res => {
                    // console.log(res)
                    this.menuList = res.data.result.qrGroups
                    this.totalCount = res.data.result.total
                    this.currentCode = res.data.result.selectCode
                    this.currentLevel = res.data.result.level
                    // 初始化当前行并播放
                    this.getCurrentRowAndPlay()
                })
        },
        getExpendKey: function () {
            var _this = this
            _this.$nextTick(function () {
                if (_this.$refs.tableMenu === undefined) {
                    return
                }
                _this.menuList.forEach(function (item) {
                    _this.$refs.tableMenu.toggleRowExpansion(item, false)
                    item.children.forEach(function (chilid) {
                        if (chilid.code === _this.currentCode) {
                            _this.expandrowkeys = []
                            // var keys = []
                            _this.expandrowkeys.push(item.key)
                            _this.$refs.tableMenu.setCurrentRow(chilid)
                        }
                    })
                })
            })
        },
        getCurrentRowAndPlay: function (key) {
            var _this = this
            _this.$nextTick(function () {
                _this.menuList.forEach(function (item) {
                    item.children.forEach(function (chilid) {
                        if ((!key && chilid.code === _this.currentCode) || (key && chilid.key === key)) {
                            _this.currentRow = chilid
                            _this.currentCode = chilid.code
                            _this.wordList = [{ key: chilid.key + '.', words: chilid.words, cnWords: chilid.cnWords }, { key: chilid.key + '.', words: chilid.words, cnWords: chilid.cnWords }]
                            _this.getExpendKey()
                            // 获取当前行并播放
                            _this.play()
                        }
                    })
                })
            })
        },
        backHome: function () {
            this.stop()
            this.$router.push('/qrhome?level=' + this.currentLevel)
        },
        timeupdate: function () {
            if (this.myAudio.currentTime > 0 && this.myAudio.duration > 0) {
                this.percentage = parseFloat((this.myAudio.currentTime / this.myAudio.duration * 100).toFixed(1))
                // console.log(this.myAudio.currentTime, this.myAudio.currentTime % (parseInt(this.myAudio.currentTime.toFixed(0))))
                this.marks = { 0: (this.myAudio.currentTime).toFixed(1), 100: (this.myAudio.duration).toFixed(1) }
            }
        },
        showDrawerMenuList: function () {
            this.drawerMenuList = true
            // 设置默认值
            this.getExpendKey()
        },
        showDrawerClockSetting: function () {
            this.drawerClockSetting = true
        },
        currentChange: function (currentRow, oldCurrentRow) {
            this.currentRow = currentRow
            var key = parseInt(this.currentRow.key)
            this.getCurrentRowAndPlay(key)
        },
        play: function (currentTime) {
            var _this = this
            console.log('start play')
            var url = window.location.origin + _this.currentRow.url
            if (_this.currentRow.url && _this.myAudio.src !== url) {
                _this.myAudio.src = url
            }
            try {
                if (currentTime && currentTime > 0) {
                    _this.myAudio.currentTime = currentTime
                }
                _this.myAudio.play()
                if (_this.timer) {
                    clearInterval(_this.timer)
                }
                _this.timer = setInterval(_this.timeupdate, 40)
                _this.audioPlaying = _this.myAudio.paused
                console.log(_this.myAudio.paused, 'paused0')
            } catch (ex) {
                alert(ex)
            }
        },
        stop: function () {
            this.myAudio.pause()
            clearInterval(this.timer)
            this.audioPlaying = this.myAudio.paused
        },
        playNext: function () {
            var key = parseInt(this.currentRow.key) + 1
            // 播放到结尾后从头播放
            if (key > this.totalCount) {
                key = 1
            }
            this.getCurrentRowAndPlay(key)
        },
        playLast: function () {
            var _this = this
            var key = parseInt(this.currentRow.key) - 1
            // 播放到开头后从最后开始播放
            if (key <= 0) {
                key = _this.totalCount
            }
            this.getCurrentRowAndPlay(key)
        },
        ended: function () {
            this.playNext()
        },
        loop: function () {
            this.audioSetting.isLoop = !this.audioSetting.isLoop
            if (this.audioSetting.isLoop) {
                this.images.uncircleImg = circle
            } else {
                this.images.uncircleImg = uncircle
            }
        },
        sliderChange: function (value) {
            var _this = this
            // _this.myAudio.removeEventListener('timeupdate', _this.timeupdate)
            if (_this.timer) {
                clearInterval(_this.timer)
            }
            _this.stop()
            _this.$nextTick(function () {
                _this.percentage = value
                if (_this.percentage && _this.myAudio.duration) {
                    var currentTime = (value / 100) * _this.myAudio.duration
                    _this.play(currentTime)
                    // _this.myAudio.addEventListener('timeupdate', _this.timeupdate)
                }
            })
        },
        addFavorite: function () {
            var sURL = window.location
            var sTitle = document.title
            this.images.unfavariteImg = favarite
            console.log(window.external, window.sidebar)
            try {
                window.external.addFavorite(sURL, sTitle)
            } catch (e) {
                console.log(e)
                try {
                    window.sidebar.addPanel(sTitle, sURL, '')
                } catch (e) {
                    console.log(e)
                    this.images.unfavariteImg = unfavarite
                    alert('抱歉，您所使用的浏览器无法完成此操作')
                }
            }
        },
        clockHandlle: function (event, value) {
            var _this = this
            _this.clockSetting = value
            if (_this.clockSetting > 0) {
                _this.images.unclockImg = clock
                setTimeout(() => {
                    _this.stop()
                    _this.$message({ message: '您的定时(' + _this.clockSetting + ')分钟已到', type: 'warning' })
                }, _this.clockSetting * 60 * 1000)
            } else {
                _this.images.unclockImg = unclock
            }
        }
    },
    destroyed () {
        var _this = this
        if (_this.timer) {
            clearInterval(_this.timer)
        }
        _this.stop()
        _this.myAudio.removeEventListener('ended', _this.ended)
    }
}
</script>
<style scoped lang="less">
.main-back-moblie,
.mian-setting-moblie,
.main-progress-moblie,
.main-tools-moblie {
    height: 60px;
    vertical-align: middle;
    line-height: 60px;
    text-align: center;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
}

.main-back-moblie {
    text-align: left;
}

.main-back-moblie li {
    float: left;
    list-style: none;
}

.main-back-moblie span {
    font-size: 20px;
    color: #409EFF;
    padding-left: 10px;
    padding-top: 5px;
    font-weight: 700;
    display: inline-block;
}

.main-tools-moblie {
    font-size: 22px;
    font-weight: 700;
    height: 80px;
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;
}

.main-tools-moblie img {
    height: 35px;
    width: 35px;
    vertical-align: middle;
}

.main-back-moblie img {
    width: 50px;
    padding: 10px;
}

.mian-setting-moblie img {
    width: 40px;
    padding: 0 10px;
}

.setting-clock {
    text-align: center;
}

.clock-check {
    background-color: #F99B0E;
    color: #fff;
    font-family: 700;
    font-size: 18px;
    border-radius: 5px;
}

.clock-check i {
    margin-left: 15px;
    font-weight: 700;
}

.body-img {
    padding-top: 30px;
    text-align: center;
    vertical-align: middle;
}

.body-img img {
    width: 100%;
}

.body-text {
    height: 100px;
    text-align: center;
    vertical-align: middle;
    padding-top: 20px;
}

.body-text span {
    font-size: 20px;
    font-weight: 700;
    margin-left: 15px;
    color: #606266;
}

.seamless-warp2 {
    overflow: hidden;
    height: 25px;
    text-align: center;
    margin: 0 auto;

    ul.item {
        list-style: none;

        li {
            list-style: none;
            float: left;
            margin-right: 10px;
            height: 40px;
        }
    }
}

/deep/.num {
    color: #409EFF;
    font-size: 16px;
    padding-right: 5px;
}

/deep/.main-body {
    overflow-y: auto !important;
}

/deep/.el-drawer__header {
    margin-bottom: 12px;
}

/deep/.el-slider__marks-text {
    margin-top: 0px;
}

/deep/.el-divider--horizontal {
    margin: 0;
}

/deep/.el-table__body tr.current-row>td {
    background-color: #b3df9e !important;
}

/deep/.el-slider__stop {
    background-color: transparent;
}
</style>



// WEBPACK FOOTER //
// src/components/qrlistening/qrstudy.vue